import React from 'react';

import Image from 'common/components/Placeholder/components/Image/Image';
import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';

import styles from './ArticleSideText.module.scss';

const ArticleSideText = () => (
  <div className={styles.ArticleSideText}>
    <Image
      color={styles.PlaceholderDefaultColor}
      className={styles.ImageSideText}
    />
    <TextBlock
      rows={6}
      color={styles.PlaceholderDefaultColor}
      className={styles.TextBlock}
    />
  </div>
);

export default ArticleSideText;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/ArticleSideText/ArticleSideText.js